<template>
  <div>
    <c-card>
      <c-card-body>
        <h1 class="h1 font-weight-normal">Adding a new site</h1>
        <p class="lead">Please follow the instructions below to add a new site to KoalaBoss.</p>
      </c-card-body>
    </c-card>

    <c-card>
      <c-card-body>
        <c-card-title>
          <strong>Step 1</strong>
          - Download and save the KoalaBoss plugin
        </c-card-title>
        <p class="lead">The KoalaBoss plugin must first be manually installed onto the site you'd like to add.</p>

        <hr />

        <p class="lead">Save the KoalaBoss plugin zip file to your computer.</p>
        <p>
          <a class="btn btn-primary" :href="pluginUrl">
            Download koalaboss.zip
          </a>
        </p>
      </c-card-body>
    </c-card>

    <c-card>
      <c-card-body>
        <c-card-title>
          <strong>Step 2</strong>
          - Install the plugin onto your WordPress site
        </c-card-title>
        <p class="lead">The KoalaBoss plugin must first be manually installed onto the site you'd like to add.</p>

        <hr />

        <c-row>
          <c-col sm="12" md="12">
            <ul class="mb-5">
              <li>Log into to your WordPress site as an Administrator</li>
              <li>
                Click
                <strong>Plugins</strong>
                in the left navigation bar
              </li>
              <li>
                Click the
                <strong>Add New</strong>
                button at the top of the page
              </li>
              <li>
                Click the
                <strong>Upload Plugin</strong>
                button at the top of the page
              </li>
              <li>
                Select the
                <strong>koalaboss.zip</strong>
                file you saved to your computer
              </li>
              <li>
                Click the
                <strong>Install Now</strong>
                button
              </li>
              <li>
                After it has been uploaded, click the
                <strong>Activate Plugin</strong>
                button
              </li>
            </ul>
          </c-col>
          <c-col sm="12" md="12">
            <video controls width="100%">
              <source :src="s3Link + '/install-mainpress-plugin.mp4'" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </c-col>
        </c-row>
      </c-card-body>
    </c-card>

    <c-card>
      <c-card-body>
        <c-card-title>
          <strong>Step 2</strong>
          - Register your new site with KoalaBoss
        </c-card-title>
        <p class="lead">Using the KoalaBoss plugin, you'll be able to add your new site.</p>

        <hr />

        <c-row>
          <c-col sm="12" md="12">
            <ul class="mb-5">
              <li>
                Click the
                <strong>KoalaBoss</strong>
                icon in the WordPress left navigation bar
              </li>
              <li>
                Enter in your KoalaBoss email address (the email you signed up with) and password, then click
                <strong>Register</strong>
                .
              </li>
              <li>Specify a new client name or choose from an existing one.</li>
              <li>If the client does not exist in KoalaBoss, it will be created for you.</li>
            </ul>
          </c-col>
          <c-col sm="12" md="12">
            <video controls width="100%">
              <source :src="s3Link + '/register-first-site.mp4'" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </c-col>
        </c-row>
      </c-card-body>
    </c-card>

    <c-card>
      <c-card-body>
        <c-card-title><strong>That's it!</strong></c-card-title>
        <p class="lead">
          Now visit the
          <router-link :to="{ name: 'dashboard' }">KoalaBoss dashboard</router-link>
          to see your new site.
        </p>
        <hr />

        <c-row>
          <c-col sm="12" md="12">
            <ul class="mb-5">
              <li>
                Your new site has been added to the
                <router-link :to="{ name: 'dashboard' }">KoalaBoss dashboard</router-link>
                , simply click the refresh icon to see your installed plugins and WordPress version.
              </li>
              <li>Click the site name to see more detailed information and to perform plugin updates.</li>
            </ul>
          </c-col>
          <c-col sm="12" md="12">
            <video controls width="100%">
              <source :src="s3Link + '/mainpress-refresh-site.mp4'" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </c-col>
        </c-row>
      </c-card-body>
    </c-card>
  </div>
</template>

<script>
export default {
  name: 'ManuallyAddSiteInstructions',
  data() {
    return {
      // defaultMessage: 'You are so close to being a BOSS! Let\'s get your first site added... Only 2 steps!',
      // message: '',
      // showAddSiteManual: false,
      // screenshotUrl: '',
      pluginUrl: 'https://koalaboss-public-assets.s3-ap-southeast-2.amazonaws.com/plugin/latest/koalaboss.zip',
      s3Link: 'https://s3-ap-southeast-2.amazonaws.com/codebrewery-digital-assets/mainpress/app/video-content',
    };
  },
};
</script>
